import { render, staticRenderFns } from "./newbaseplan.vue?vue&type=template&id=2218f604&scoped=true&"
import script from "./newbaseplan.vue?vue&type=script&lang=js&"
export * from "./newbaseplan.vue?vue&type=script&lang=js&"
import style0 from "./newbaseplan.vue?vue&type=style&index=0&id=2218f604&prod&lang=scss&scoped=true&"
import style1 from "./newbaseplan.vue?vue&type=style&index=1&id=2218f604&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2218f604",
  null
  
)

export default component.exports